import {
  MAP_BOUNDS,
  MAP_POLYLINES,
  MAP_HIDDEN_ROUTES,
  MAP_MARKERS_HIDDEN,
  MAP_UNSCHEDULED_MARKERS_HIDDEN,
  MAP_MARKERS_CLUSTERED,
  MAP_LAYERS_HIDDEN,
  MAP_TILES_DARK,
  MAP_HOVER_STOP,
  MAP_HOVER_ROUTE,
  MAP_CURRENT_DRIVER,
  MAP_PINPOINT_DRIVER,
  RESET_STATE,
  SET_DRIVER_LOCATIONS,
  SET_DRIVER_LIVE,
  SET_RENDERED_POLYLINES,
  MAP_SNAP_TO_ROAD_VISIBLE,
  SET_MAP_ZOOM,
  SET_REFIT_HASH,
  SET_MAP_CENTER,
  MAP_IS_DRIVER_LIVE_LOCATION_VISIBLE
} from "../actions/types";
import { setCookie, getCookie } from "../../utils/cookies";

let currentMapTheme = getCookie("maptheme");
let currentMarkersHidden = getCookie("markersHidden");
let currentUnscheduledMarkersHidden = getCookie("unscheduledMarkersHidden");
let currentSnapToRoadEnabled = getCookie("snapToRoadEnabled");
let currentMarkersClustered = getCookie("markersClustered");
let currentIsDriverLocationVisible = getCookie("isDriverLiveLocationVisible");
currentMapTheme = currentMapTheme ? currentMapTheme : "light";
currentMarkersHidden = currentMarkersHidden ?? false;
currentUnscheduledMarkersHidden = currentUnscheduledMarkersHidden ?? false;
currentSnapToRoadEnabled = currentSnapToRoadEnabled ?? false;
currentMarkersClustered = currentMarkersClustered ?? true;
currentIsDriverLocationVisible = currentIsDriverLocationVisible ?? true;

const initialState = {
  bounds: {},
  polylines: {},
  renderedPolylines: {},
  hiddenRoutes: [],
  markersHidden: currentMarkersHidden,
  unscheduledMarkersHidden: currentUnscheduledMarkersHidden,
  snapToRoadEnabled: currentSnapToRoadEnabled,
  markersClustered: currentMarkersClustered,
  isDriverLiveLocationVisible: currentIsDriverLocationVisible,
  layersHidden: false,
  tilesDark: currentMapTheme === "dark",
  hoverStop: null,
  hoveredRouteId: null,
  mapZoom: null,
  refitHash: "",
  currentDriver: null,
  pinpointDriver: null,
  driverLocations: {},
  driversLiveStatus: {}
};

export function mapReducer(state = initialState, action) {
  switch (action.type) {
    case MAP_BOUNDS:
      return {
        ...state,
        bounds: action.obj
      };
    case MAP_POLYLINES:
      return {
        ...state,
        polylines: action.obj
      };
    case MAP_HIDDEN_ROUTES:
      return {
        ...state,
        hiddenRoutes: action.arr
      };
    case SET_MAP_ZOOM:
      return {
        ...state,
        mapZoom: action.payload
      };
    case SET_MAP_CENTER:
      return {
        ...state,
        mapCenter: action.payload
      };
    case SET_REFIT_HASH:
      return {
        ...state,
        refitHash: action.str
      };
    case MAP_SNAP_TO_ROAD_VISIBLE:
      setCookie("snapToRoadEnabled", action.bool || "", 365);
      return {
        ...state,
        snapToRoadEnabled: action.bool
      };
    case MAP_MARKERS_HIDDEN:
      setCookie("markersHidden", action.val || "", 365);
      return {
        ...state,
        markersHidden: action.val
      };
    case MAP_UNSCHEDULED_MARKERS_HIDDEN:
      setCookie("unscheduledMarkersHidden", action.val || "", 365);
      return {
        ...state,
        unscheduledMarkersHidden: action.val
      };
    case MAP_IS_DRIVER_LIVE_LOCATION_VISIBLE:
      setCookie("isDriverLiveLocationVisible", action.payload || "", 365);
      return {
        ...state,
        isDriverLiveLocationVisible: action.payload
      };
    case MAP_MARKERS_CLUSTERED:
      setCookie("markersClustered", action.val || "", 365);
      return {
        ...state,
        markersClustered: action.val
      };
    case MAP_LAYERS_HIDDEN:
      return {
        ...state,
        layersHidden: action.val
      };
    case MAP_TILES_DARK:
      // Make map theme choice persistant
      setCookie("maptheme", action.val, 365);
      return {
        ...state,
        tilesDark: action.val === "dark"
      };
    case MAP_HOVER_STOP:
      return {
        ...state,
        hoverStop: action.val
      };
    case MAP_HOVER_ROUTE:
      return {
        ...state,
        hoveredRouteId: action.id
      };
    case SET_DRIVER_LOCATIONS:
      return {
        ...state,
        driverLocations: { ...state.driverLocations, ...action.obj }
      };
    case SET_DRIVER_LIVE:
      return {
        ...state,
        driversLiveStatus: {
          ...state.driversLiveStatus,
          ...action.payload
        }
      };
    case MAP_CURRENT_DRIVER:
      return {
        ...state,
        currentDriver: action.val
      };
    case MAP_PINPOINT_DRIVER:
      return {
        ...state,
        pinpointDriver: action.val
      };
    case SET_RENDERED_POLYLINES:
      return {
        ...state,
        renderedPolylines: action.obj
      };
    case RESET_STATE:
      return {
        ...initialState,
        bounds: state.bounds,
        tilesDark: state.tilesDark,
        markersHidden: state.markersHidden,
        unscheduledMarkersHidden: state.unscheduledMarkersHidden,
        snapToRoadEnabled: state.snapToRoadEnabled,
        markersClustered: state.markersClustered,
        polylines: {},
        renderedPolylines: {}
      };
    default:
      return state;
  }
}
